function initialState() {
  return {
    bpaSideNav: '',
  }
}

const bpa = {
  namespaced: true,
  state: initialState,
  mutations: {
    changeBPASideNav(state, value) { state.bpaSideNav = value },
    resetStoreData(state) {
      const localState = initialState()
      Object.keys(state).forEach((prop) => {
        state[prop] = localState[prop]
      })
    },
  },
  actions: {
    changeBPASideNav({ commit }, value) { commit('changeBPASideNav', value) },
  },
}

export default bpa;
